mutation ReorderTorahColumnOverlays($barMitzvah: String!, $orderedIds: [ID!]!) {
  reorderTorahColumnOverlays(barMitzvah: $barMitzvah, orderedIds: $orderedIds) {
    ok
    errors
  }
}
